export const enum I18nNamespace {
  Common = 'common',
  Core = 'core',
  UserManagement = 'userManagement',
  Validation = 'validation',
  CourseManagement = 'courseManagement',
  ScenarioSection = 'scenarioSection',
  GroupManagement = 'groupManagement',
  ScheduledCalls = 'scheduledCalls',
  GlobalAssets = 'globalAssets',
  Dashboard = 'dashboard',
  ScenarioEditor = 'scenarioEditor',
  MyDashboard = 'myDashboard',
  Translator = 'translator',
  EvaluationProtocols = 'evaluationProtocols',
  ScenarioPlayer = 'scenarioPlayer',
  CompanyManagement = 'companyManagement',
  Personas = 'personas',
  DecisionSupport = 'decisionSupport',
  Exercises = 'exercises'
}
